<template>
  <div class="bg-white p-4 rounded shadow-sm">
    <!-- Mensagem de sucesso caso a api retorne 200 -->
    <success
      :control="controlSuccess"
      :msg="'<strong>Recebemos sua mensagem!</strong><br>Entraremos em contato em breve.'"
      data-aos="fade-in-zoom"
      data-aos-once="true"
    />

    <!-- Mensagem em caso de erro na api -->
    <error
      :control="controlError"
      :msg="'Erro na solicitação. Por favor, tente novamente.'"
      data-aos="fade-in-zoom"
      data-aos-once="true"
    />

    <h5 class="text-secondary text-center font-weight-normal">
      <strong>Cadastre seu veículo</strong> e nossos consultores entrarão em
      <strong>contato</strong>
    </h5>

    <form class="mt-4 px-3 d-flex flex-column align-items-center">
      <b-form-group class="w-100 mt-0">
        <input type="text" v-model="nome" required="required" />
        <label for="input" class="control-label" style="font-size: 90%;">Nome</label>
        <i class="bar"></i>
      </b-form-group>

      <b-form-group class="w-100 mt-1">
        <input type="tel" v-model="telefone" required="required" />
        <label for="input" class="control-label" style="font-size: 90%;">Telefone</label>
        <i class="bar"></i>
      </b-form-group>

      <b-form-group class="w-100 mt-1">
        <input type="text" v-model="cidade" required="required" />
        <label for="input" class="control-label" style="font-size: 90%;">Cidade</label>
        <i class="bar"></i>
      </b-form-group>

      <b-form-group class="w-100 mt-1">
        <input type="text" v-model="modelo" required="required" />
        <label for="input" class="control-label" style="font-size: 90%;">Veículo, ano</label>
        <i class="bar"></i>
      </b-form-group>

      <div class="checkbox mt-0 mb-4 d-flex align-items-center">
        <label>
          <input type="checkbox" @click="active = !active" />
          <i class="helper" style="top: 3px;"></i>Li e concordo com as regras
        </label>
      </div>

      <div class="d-flex flex-wrap justify-content-center">
        <b-button
          variant="purple"
          v-html="textSubmit"
          :disabled="stateSubmit"
          @click.prevent="sendLead"
          class="text-uppercase text-white px-5 py-2 my-3"
        />
        <router-link
          v-if="(this.$route.path !== '/')"
          to="/"
          class="btn-light text-secondary text-uppercase text-white px-4 d-flex align-items-center py-2 mb-5 ml-2"
        >
          <i class="fas fa-angle-left mr-2"></i>
          voltar ao home
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
import Success from '@/components/Success.vue'
import Error from '@/components/Error.vue'
import axios from 'axios'

import AOS from 'aos'
import 'aos/dist/aos.css'

AOS.init()

export default {
  components: {
    Success,
    Error
  },
  data: () => {
    return {
      controlSuccess: false,
      controlError: false,
      textSubmit: 'quero vender meu veículo',
      stateSubmit: false,
      active: false, 
      nome: '', 
      telefone: '', 
      cidade: '', 
      modelo: '',
      API: 'https://mail-sender-gm2gqdbgaa-uc.a.run.app'
    }
  }, 
  methods: {
    async sendLead () {
      // Mudando o estado do botão de submit
      this.textSubmit = '<div class="spinner-border spinner-border-sm text-light mr-2" role="status"><span class="sr-only">Loading...</span></div>enviando...'
      this.stateSubmit = true

      let self = this
      await axios.post(`${self.API}/mail`, {
        headers: {
          "Content-Type": "application/json"
        },
        params: {
          title: 'Vaapty - Lead vindo do site',
          data: [
            { 
              legend: "Nome", 
              desc: self.nome
            }, 
            { 
              legend: "Telefone", 
              desc: self.telefone 
            }, 
            { 
              legend: "Cidade", 
              desc: self.cidade 
            }, 
            { 
              legend: "Veículo", 
              desc: self.modelo 
            }
          ], 
          host_body: {
            Name: "smtp.weblink.com.br",
            Port: 587,
            User: "contato@mythoth.com.br",
            Pass: "thoth10"
          }
        }
      })
        .then(() => {
          // Habilitando mensagem de sucesso
          self.controlSuccess = true

          setTimeout(() => {
            self.controlSuccess = false
          }, 5000)

          // Zerando o estado dos inputs
          self.nome = ''
          self.telefone = ''
          self.cidade = ''
          self.modelo = ''
        })
        .catch(() => {

          this.controlError = true
          setTimeout(() => {
            self.controlError = false
          }, 4000)

        })

        // Retornando ao estado original do botão pós envio de formulário
        this.textSubmit = 'quero vender meu veículo'
        this.stateSubmit = false
    }
  }, 
}
</script>
